import $ from 'jquery';
import 'slick-carousel';

export default class Slider {
  constructor() {
    this.init();
  }

  init() {
    this.sliderSetting();
    $(window).on('resize', () => {
      this.sliderSetting();
    });
  }

  sliderSetting() {
    // .js-clinic_slider の設定
    $('.js-clinic_slider').not('.slick-initialized').slick({
      slidesToShow: 3,
      arrows: true,
      dots: true,
      speed: 1000,
      autoplay: false,
      pauseOnHover: false,
      variableWidth: true,
      prevArrow: '<div class="slide-arrow prev-arrow"></div>',
      nextArrow: '<div class="slide-arrow next-arrow"></div>',
      responsive: [{
        breakpoint: 769,
        settings: {
          slidesToShow: 1
        }
      }]
    });

    // .js-ind_slider の設定（元のjQueryコードをベースに追加）
    $('.js-ind_slider').not('.slick-initialized').slick({
      slidesToShow: 2,
      infinite: true,
      dots: true,
      arrows: true,
      prevArrow: '<div class="slide-arrow prev-arrow"></div>',
      nextArrow: '<div class="slide-arrow next-arrow"></div>',
      variableWidth: false,
      responsive: [{
        breakpoint: 769,
        settings: {
          slidesToShow: 1
        }
      }]
    });

    // 同期スライダー：メインとサムネイル
   $('.js-box_main_slider').not('.slick-initialized').slick({
      slidesToShow: 1,
      fade: true,
      variableWidth: false,
      autoplay: false,
      arrows: false,
      asNavFor: '.js-thumbnail_slider',
    });

    // スライドの数を数える
    const slideCount = $('.js-thumbnail_slider > div').length;

    $('.js-thumbnail_slider').not('.slick-initialized').slick({
      slidesToShow: slideCount,
      asNavFor: '.js-box_main_slider',
      variableWidth: false,
      focusOnSelect: true,
    });
  }
}
